import React from 'react';
import { makeStyles } from 'src/makeStyles';
import { colors } from '../../../constants/styleConstants';

const useStyles = makeStyles()({
  titleTextContainer: {
    fontFamily: 'Roboto',
    fontSize: 20,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
  },

  cardTitle: {
    display: 'flex',
    marginBottom: 16,
  },
  cardTitleOverriden: {
    display: 'flex',
    marginBottom: '0px !important',
  },

  titleLinkContainer: {
    margin: 'auto',
    marginRight: 0,
    cursor: 'pointer',
  },

  subTitle: {
    marginBottom: 15,
  },
});

const Tag = ({ tagName, children, ...props }) => React.createElement(tagName, props, children);

const StubPageCardTitle = ({
  title,
  titleActionComponent,
  subTitle,
  totalCount,
  tagName,
  className,
  children,
  overrideStyles,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={overrideStyles ? className.cardTitleOverriden : cx(classes.cardTitle, className)}>
      <Tag tagName={tagName || 'h2'} className={overrideStyles ? className : classes.titleTextContainer}>
        {title} {totalCount && `(${totalCount})`}
      </Tag>
      &nbsp;
      {children}
      {titleActionComponent && <div className={classes.titleLinkContainer}>{titleActionComponent}</div>}
      {subTitle && <div className={classes.subTitle}>{subTitle}</div>}
    </div>
  );
};

export default StubPageCardTitle;
